import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'app-analytics-overview',
    templateUrl: './analytics-overview.component.html',
    styleUrls: ['./analytics-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalyticsOverviewComponent{
  @Input() analytics: any;
}
